import { Box, BoxProps } from '@chakra-ui/react'
import { Surface } from 'gl-react-dom'
import GLTransition from 'react-gl-transition'
import GLImage from 'gl-react-image'
import { useMeasure } from 'react-use'
import * as React from 'react'

// eslint-disable-next-line
import fragFile from '!!raw-loader!./shader.frag'

export type CarouselProps = BoxProps & {
  from: string | HTMLImageElement
  to: string
  progress: number
  fit: string
}

const Carousel: React.FC<CarouselProps> = ({ from, to, progress, fit = 'cover', ...others }) => {
  const [ref, { width, height }] = useMeasure()
  const transition = {
    // eslint-disable-next-line
    glsl: fragFile,
    defaultParams: { amplitude: 300, speed: 50 },
  }

  return (
    <>
      <Box ref={ref} {...others}>
        <Surface width={width} height={height}>
          {progress > 0 ? (
            <GLTransition
              from={<GLImage source={from} resizeMode={fit} />}
              to={<GLImage source={to} resizeMode={fit} />}
              progress={progress}
              transition={transition}
            />
          ) : (
            <GLImage source={from} resizeMode={fit} />
          )}
        </Surface>
      </Box>
    </>
  )
}

export default Carousel
